document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth < 750;
  const accordions = document.querySelectorAll('.product__accordion details');

  if (isMobile) {
    // Mobile: nur erste Reihe offen, Accordion-Verhalten
    const firstDetails = document.querySelector('.product__accordion details');
    if (firstDetails) firstDetails.setAttribute('open', '');

    document.querySelector('[id^="ProductInfo-"]')?.addEventListener('click', function (e) {
      const clickedSummary = e.target.closest('summary');
      if (!clickedSummary) return;
      const clickedDetails = clickedSummary.closest('details');
      if (!clickedDetails) return;

      document.querySelectorAll('.product__accordion details[open]').forEach(function (openDetails) {
        if (openDetails !== clickedDetails) openDetails.removeAttribute('open');
      });
    });

  } else {
    // Desktop: alle offen, Klapp-Verhalten deaktivieren
    accordions.forEach(function (details) {
      details.setAttribute('open', '');
    });
    document.body.classList.add('accordion-disabled');
  }
});
